
export const new_Options = "new_Options";
export const reset_Options = "reset_Options";

export const start_login = "start_login";
export const login_success = "login_success";
export const login_failure = "login_failure";
export const logout = "logout";

